"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.algoliaFeatureConfig = void 0;
function makeAlgoliaFeatureConfig(primaryIndexName, additionalIndexNames = []) {
    return {
        primaryIndexName,
        additionalIndexNames,
    };
}
/**
 * Configuration data for how our search indices are currently structured.
 */
exports.algoliaFeatureConfig = {
    parts: makeAlgoliaFeatureConfig("parts_search_v12"),
    projects: makeAlgoliaFeatureConfig("documents_search"),
    // Sometimes we want to use this index for components search, and the difference between this index
    // and the `part` index above is ranking:
    // - if you want results to rank by star count, use this one
    // - if you want results to rank by overall relevance, use the `part` index
    projectsByStars: makeAlgoliaFeatureConfig("documents_search_star_desc"),
    users: makeAlgoliaFeatureConfig("users_search"),
    organizations: makeAlgoliaFeatureConfig("organizations_search"),
};
//# sourceMappingURL=featureConfig.js.map